import { array, boolean, object, optional, string } from 'zod';

export const CHOICE_TEXT_REQUIRED_MESSAGE = 'Choice text is required';

export const QuizMultipleDataSchema = object({
  choiceList: array(
    object({
      key: string(),
      text: optional(string()),
      richText: optional(string()),
      imageUrl: optional(string()),
      isAnswer: boolean(),
    }).refine(
      data => {
        if (!data.text && !data.imageUrl) return false;
        return true;
      },
      {
        message: 'Choice text or image is required',
        path: ['text'],
      },
    ),
  ).refine(
    data => {
      return data.some(choice => choice.isAnswer);
    },
    {
      message: 'At least one choice must be an answer',
      path: ['choiceList'],
    },
  ),
});
